<template>
    <div class="projects-category__wrap">

        <div class="projects-category__header">
            <h1 class="header header--1 header--no-margin-bottom">
                {{categoryName}}
            </h1>
        </div>

        <div class="projects-category__filter">
            <list-filter :years="years" :yearsFilter="yearsFilter"></list-filter>
        </div>

        <div class="projects-category__projects" :class="{
            'projects-category__projects--loading': loading
        }">

            <div class="projects-category__loader">
                <div class="loader">
                    <span class="loader__square"></span>
                    <span class="loader__square"></span>
                    <span class="loader__square"></span>
                    <span class="loader__square"></span>
                </div>
            </div>

            <list :posts="projectsFormatted"></list>
        </div>
    </div>
</template>

<script>
    /* global WP */
    import listFilter from './list-filter.vue';
    import list from './list.vue';
    import $ from 'jquery';
    import has from 'lodash/has';
    import sortBy from 'lodash/sortBy';

    export default {
        name: 'category',
        props: {
            categoryName: {
                type: String,
                required: true
            },
            taxonomy: {
                type: String,
                required: true
            },
            termId: {
                type: Number,
                required: true
            },
            yearsFilter: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                loading: true,
                projects: [],
                years: []
            }
        },
        computed: {
            projectsFormatted() {
                const projects = this.sortProjectsByFeatured(this.projects);

                if (!this.hasFilter()) {
                    return projects;
                }

                return projects.map(project => {
                    project.fields.featured = false;
                    return project;
                })
            },
        },
        components: {
            list,
            listFilter
        },
        created() {
            this.fetchYears();
            this.fetchProjects();
        },
        watch: {
            $route() {
                this.fetchProjects()
            },
        },
        methods: {
            onError(response) {
                console.error('error', response);
            },
            onResponse(response, type) {
                if (!Array.isArray(response)) {
                    this.onError();
                }

                this[type] = response;
            },
            onAlways() {
                this.loading = false;
            },
            hasFilter() {
                return this.yearsFilter.length > 0;
            },
            sortProjectsByFeatured(projects) {
                return sortBy(projects, project => project.fields.featured !== true);
            },
            buildProjectsQuery() {
                const query = {
                    per_page: 999,
                    taxonomyQuery: [{
                        taxonomy: this.taxonomy,
                        term: this.termId
                    }],
                    metaQuery: [],
                    lang: WP.lang
                };

                if (!this.hasFilter()) {
                    return query;
                }

                query.metaQuery.push({
                    key: 'project_date_end',
                    value: this.yearsFilter
                });

                return query;
            },
            fetchProjects() {
                this.loading = true;

                return $.get('/wp-json/wp/v2/project/', this.buildProjectsQuery())
                    .done(response => {
                        this.onResponse(response, 'projects')
                    })
                    .fail(this.onError)
                    .always(this.onAlways)
            },
            fetchYears() {
                return $.get(`/wp-json/wp/v2/project-category/${this.termId}`, {
                    per_page: 999,
                    lang: WP.lang
                })
                    .done(response => {
                        this.onResponse(response.years, 'years')
                    })
                    .fail(this.onError)
                    .always(this.onAlways)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// category.vue?26aa92a0